import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import "./SetupCompleted.css";
import Cross from "../../../../assets/images/onboardingImages/crossBlack.svg";
import Arrow from "../../../../assets/images/onboardingImages/longArrow.svg";
import CopyLogo from "../../../../assets/images/onboardingImages/logo_black.svg";
import { useLocation, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import CopyIcon from "../../../../assets/images/Copy.svg";
import settingCompleted from "../../../../assets/images/onboardingImages/setting.gif";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { storeUser } from "../../../../redux/users/usersSlice";
import { useDispatch, useSelector } from "react-redux";
import { toastify } from "../../../../helpers/toast/toastify";
import { fetchUser } from "../../../../helpers/helper";

const SetupCompleted = () => {
  const { state:locationState } = useLocation();
  const [show, setShow] = useState(true); // Modal visibility
  const [leaderCommunityName, setLeaderCommunityName] = useState("");
  const { user } = useSelector((state) => state.user);

  const api = useApi();
  const dispatch = useDispatch();
  const isOnBoardingComplete =
  user?.onboarding?.isCommunityCreated &&
  user?.onboarding?.connect &&
  user?.onboarding?.payment &&
  user?.onboarding?.subscribed &&
  user?.onboarding?.isVerified;
  useEffect(() => {
    setLeaderCommunityName(user?.leaderCommunity?.name);
  }, [user]);
  useEffect(()=>{
    if(!locationState&&!(locationState?.from==="onboarding")){
      navigate("/leader/dashboard", { replace: true });
      return;
     }
  },[])

  const handleClose = async () => {
    const response = await api("post", "users/update", {
      "onboarding.isVerified": true,
    });

    await fetchUser(api, dispatch, storeUser);

    navigate("/leader/dashboard", { replace: true });
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const navigate = useNavigate();
  

  // if(isOnBoardingComplete){
  //   navigate("/leader/dashboard", { replace: true });
  //   return;
  //  }
  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="custom-onboarding-modal"
        backdropClassName="onboarding-custom-backdrop"
      >
        <Modal.Body>
          <button
            type="button"
            className="reverseArrow"
            onClick={() => {
              navigate("/leader/onboarding/importantUpdates", {
                replace: true,
              });
            }}
          >
            <img src={Arrow} alt="Arrow Image" />
          </button>
          <button type="button" className="CrossIcon" onClick={handleClose}>
            <img src={Cross} alt="Cross Image" />
          </button>
          <div className="onboardingContentBox top58px">
            <h2 className="title">
              <span>Yay! Setup is compeleted</span>
            </h2>
            <img src={settingCompleted} className="gifImage" alt="" />
            <p className="desc bottom9px">Here is your unique sign up page</p>
            <div className="formBox">
              <div className="mb-59px">
                <InputGroup className="onboardingInput custom">
                  <Form.Control
                    placeholder="Username"
                    aria-label="Username"
                    aria-describedby="copuCommunity"
                    value={`${document.location.origin.replace(
                      document.location.pathname,
                      ""
                    )}/community/${leaderCommunityName.split(" ").join("")}`}
                    disabled
                  />
                  <InputGroup.Text id="copuCommunity">
                    <button type="button">
                      <img
                        src={CopyIcon}
                        alt="Copy icon"
                        onClick={() => {
                          // Construct the community link using template literals
                          const communityLink = `${document.location.origin.replace(
                            document.location.pathname,
                            ""
                          )}/community/${leaderCommunityName
                            .split(" ")
                            .join("")}`;

                          // Attempt to copy the link to the clipboard
                          navigator.clipboard
                            .writeText(communityLink)
                            .then(() => {
                              // Success: Show a toast notification
                              toastify(
                                "Community link copied to clipboard!",
                                "success"
                              );
                            })
                            .catch((error) => {
                              // Error: Handle clipboard write failure and show a toast notification
                              console.error("Clipboard write error:", error);
                              toastify(
                                "Failed to copy community link to clipboard.",
                                "error"
                              );
                            });
                        }}
                      />
                    </button>
                  </InputGroup.Text>
                </InputGroup>
              </div>
              <button
                type="button"
                className="ExtraTierBtn"
                onClick={handleClose}
              >
                Ok,let's go!
              </button>
            </div>
          </div>
          <div className="paginationDots">
            <button className="dot "></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot active"></button>
            <button className="dot"></button>
          </div>
          <div className="copyrightBox">
            <p className="">
              Powered by{" "}
              <span className="spanMain">
                <img src={CopyLogo} alt="" />
              </span>
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default SetupCompleted;
